import { forwardRef } from "react";
import TextFieldMU, { type TextFieldProps } from "@mui/material/TextField";
import TextError from "../TextError";

const TextField = forwardRef<HTMLDivElement, TextFieldProps>((props, ref) => {
  const { helperText, ...rest } = props;
  return (
    <>
      {/*<div className={styles.inputWrapper}>*/}
      <TextFieldMU
        ref={ref}
        {...rest}
        helperText={<>{helperText && <TextError>{helperText}</TextError>}</>}
      />
      {/* {helperText && (*/}
      {/*        <Typography className={styles.error}>*/}
      {/*            <AttentionIcon*/}
      {/*                size={16}*/}
      {/*                sx={{*/}
      {/*                    color: 'var(--color-text-error)',*/}
      {/*                }}*/}
      {/*            />*/}
      {/*            {helperText}*/}
      {/*        </Typography>*/}
      {/*)}*/}
      {/*</div>*/}
    </>
  );
});

TextField.displayName = "TextField";

export default TextField;
